// @ts-nocheck
(function () {
  const root = document.querySelector('[data-mdock]');
  if (!root) return;

  const trigger       = root.querySelector('[data-mdock-trigger]');
  const overlay       = root.querySelector('[data-mdock-overlay]');
  const panel         = root.querySelector('[data-mdock-panel]');
  const body          = root.querySelector('[data-mdock-body]');
  const closeBtn      = root.querySelector('[data-mdock-close]');
  const gearBtn       = root.querySelector('[data-mdock-settings-trigger]');
  const searchInput   = root.querySelector('[data-mdock-search]');
  const searchSubmit  = root.querySelector('[data-mdock-search-submit]');
  const searchPill    = root.querySelector('.mdock__search');
  const menuWindow    = root.querySelector('[data-mdock-window]');
  const sheet         = root.querySelector('.mdock__sheet');

  if (!trigger || !overlay || !panel || !body || !searchInput) {
    console.warn('[mdock] Required elements not found.');
    return;
  }

  // ── Read menus ───────────────────────────────────────────────────────────────
  const jsonEl = root.querySelector('[data-mdock-json]');
  let MENUS = { root: [], icons: [] };
  try {
    MENUS = jsonEl ? JSON.parse(jsonEl.textContent || '{}') : MENUS;
  } catch (e) { console.warn('[mdock] Invalid JSON', e); }

  // ── State ────────────────────────────────────────────────────────────────────
  let parentState      = null;
  let openAccordionKey = null;

  // ── Helpers ──────────────────────────────────────────────────────────────────
  function getTitle(item)    { return item?.title ?? item?.name ?? item?.text ?? item?.label ?? 'Item'; }
  function getUrl(item)      { return item?.url ?? item?.link ?? item?.href ?? '#'; }
  function getChildren(item) {
    const c = item?.links ?? item?.items ?? item?.children ?? [];
    return Array.isArray(c) ? c : [];
  }
  function escapeHtml(str) {
    return String(str ?? '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  const iconTemplate = root.dataset.iconTemplate || '';
  function getAutoAssetUrl(item) {
    const handle = item?.handle;
    if (handle && iconTemplate) return iconTemplate.replace('__HANDLE__', handle);
    return '';
  }

  // ── Sheet padding helpers ─────────────────────────────────────────────────────
  function setSheetPaddingForPrefs() {
    if (sheet) sheet.style.paddingBottom = '';
  }
  function resetSheetPadding() {
    if (sheet) sheet.style.paddingBottom = '';
  }

  // ── Slide animation ──────────────────────────────────────────────────────────
  function animateBody() {
    body.classList.remove('is-animating');
    void body.offsetWidth;
    body.classList.add('is-animating');
    body.addEventListener('animationend', () => body.classList.remove('is-animating'), { once: true });
  }

  // ── Window level ─────────────────────────────────────────────────────────────
  function setWindowLevel(level) {
    if (!menuWindow) return;
    menuWindow.classList.toggle('is-level1',  level === 'level1');
    menuWindow.classList.toggle('is-sublevel', level === 'sublevel');
    menuWindow.classList.toggle('is-prefs',    level === 'prefs');
  }

  // ── Close button visibility ───────────────────────────────────────────────────
  function setCloseBtnVisible(visible) {
    if (closeBtn) {
      closeBtn.style.visibility = visible ? '' : 'hidden';
      closeBtn.style.opacity    = visible ? '' : '0';
    }
  }

  // ── Open / Close ─────────────────────────────────────────────────────────────
  function open() {
    root.classList.add('is-open');
    overlay.hidden = false;
    panel.hidden   = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    clearSearch();
    setCloseBtnVisible(true);
    resetSheetPadding();
  }

  function close() {
    root.classList.remove('is-open');
    overlay.hidden = true;
    panel.hidden   = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    parentState      = null;
    openAccordionKey = null;
    body.innerHTML   = '';
    if (menuWindow) menuWindow.classList.remove('is-level1','is-sublevel','is-prefs');
    clearSearch();
    setCloseBtnVisible(true);
    resetSheetPadding();
  }

  // ── Search ───────────────────────────────────────────────────────────────────
  function clearSearch() {
    if (searchInput) searchInput.value = '';
    updateSearchArrow();
  }

  function buildViewAllUrl(q) { return `/search?${new URLSearchParams({ q })}`; }

  function updateSearchArrow() {
    const val = (searchInput?.value || '').trim();
    if (searchSubmit) searchSubmit.classList.toggle('is-visible', val.length > 0);
    if (searchPill)   searchPill.classList.toggle('has-value', val.length > 0);
  }

  // ── Render Level 1 ───────────────────────────────────────────────────────────
  function renderLevel1(items) {
    body.innerHTML   = '';
    parentState      = null;
    openAccordionKey = null;
    setWindowLevel('level1');
    setCloseBtnVisible(true);
    resetSheetPadding();
    animateBody();

    (items || []).forEach(item => {
      const children    = getChildren(item);
      const hasChildren = children.length > 0;
      body.appendChild(makeItemEl({
        title:    getTitle(item),
        url:      getUrl(item),
        hasArrow: hasChildren,
        isStatic: !hasChildren,
        onClick:  hasChildren ? () => {
          parentState = { items };
          renderSubLevel(getTitle(item), children);
        } : null
      }));
    });
  }

  // ── Render Sub-level ─────────────────────────────────────────────────────────
  function renderSubLevel(title, items) {
    body.innerHTML   = '';
    openAccordionKey = null;
    setWindowLevel('sublevel');
    setCloseBtnVisible(true);
    resetSheetPadding();
    animateBody();

    body.appendChild(makeItemEl({
      title, hasArrow: true, isActive: true,
      onClick: () => {
        if (parentState) renderLevel1(parentState.items);
        else renderLevel1(MENUS.root || []);
      }
    }));

    items.forEach(item => {
      const children = getChildren(item);
      if (children.length > 0) {
        body.appendChild(makeAccordionBlock(item, children));
      } else {
        body.appendChild(makeItemEl({ title: getTitle(item), url: getUrl(item), isStatic: true }));
      }
    });
  }

  // ── Render Preferences ───────────────────────────────────────────────────────
  function renderPreferences() {
    body.innerHTML = '';
    setWindowLevel('prefs');
    setCloseBtnVisible(false);
    setSheetPaddingForPrefs(); // shrink sheet padding so prefs sit at bottom edge
    animateBody();

    const desktopPanel = document.querySelector('.settings-panel');

    // Header: full grey row, fully clickable = back
    const header = document.createElement('button');
    header.type = 'button';
    header.className = 'mdock__prefs-header';
    header.addEventListener('click', () => {
      setCloseBtnVisible(true);
      resetSheetPadding();
      if (parentState) renderLevel1(parentState.items);
      else renderLevel1(MENUS.root || []);
    });

    const backIcon = document.createElement('span');
    backIcon.className = 'mdock__prefs-back';
    backIcon.innerHTML = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 1L1 7L7 13" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const titleSpan = document.createElement('span');
    titleSpan.className = 'mdock__prefs-title';
    titleSpan.textContent = 'Select your Preferences';

    header.appendChild(backIcon);
    header.appendChild(titleSpan);
    body.appendChild(header);

    // Toggle groups
    const view = document.createElement('div');
    view.className = 'mdock__prefs';
    if (desktopPanel) {
      desktopPanel.querySelectorAll('.settings-group').forEach(group => {
        view.appendChild(group.cloneNode(true));
      });
    }
    body.appendChild(view);
    initSegments(view);

    view.querySelectorAll('.settings-option--language').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = link.dataset.target;
        if (target) document.querySelector(`#${target}`)?.click();
      });
    });

    view.querySelectorAll('.settings-option--language').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const target = link.dataset.target;
        if (target) document.querySelector(`#${target}`)?.click();
      });
    });

    // Save button
    const saveBtn = document.createElement('button');
    saveBtn.type = 'button';
    saveBtn.className = 'mdock__prefs-save';
    saveBtn.textContent = 'Save Preferences';
    saveBtn.addEventListener('click', () => {
      const mobileGroups  = [...view.querySelectorAll('.settings-group[data-segment]')];
      const desktopGroups = desktopPanel ? [...desktopPanel.querySelectorAll('.settings-group[data-segment]')] : [];

      mobileGroups.forEach((mGroup, i) => {
        const dGroup    = desktopGroups[i];
        const activeOpt = mGroup.querySelector('.settings-option.is-active, .settings-option--language.is-active');
        if (!activeOpt) return;

        const val = activeOpt.dataset.value || activeOpt.dataset.lang || activeOpt.dataset.unit;

        if (dGroup) {
          dGroup.querySelectorAll('.settings-option, .settings-option--language').forEach(opt => {
            const dVal = opt.dataset.value || opt.dataset.lang || opt.dataset.unit;
            opt.classList.toggle('is-active', dVal === val);
          });
        }

        if (activeOpt.dataset.unit) {
          try { localStorage.setItem('novu_unit', activeOpt.dataset.unit); } catch (e) {}
        }

        if (activeOpt.dataset.target) {
          document.querySelector(`#${activeOpt.dataset.target}`)?.click();
        }

        if (activeOpt.href && activeOpt.href !== '#' && activeOpt.classList.contains('settings-option--language')) {
          window.location.href = activeOpt.href;
        }
      });

      const desktopSave = document.querySelector('.settings-save');
      if (desktopSave) desktopSave.click();

      close();
    });
    body.appendChild(saveBtn);
  }

  // ── initSegments ─────────────────────────────────────────────────────────────
  function initSegments(container) {
    container.querySelectorAll('.settings-group[data-segment]').forEach(seg => {
      const thumb   = seg.querySelector('.settings-thumb');
      const buttons = [...seg.querySelectorAll('.settings-option, .settings-option--language')];
      if (!thumb || buttons.length < 2) return;

      if (seg.hasAttribute('data-units')) {
        try {
          const stored = (localStorage.getItem('novu_unit') || '').toLowerCase();
          if (stored) {
            const idx = buttons.findIndex(b => (b.dataset.unit || '').toLowerCase() === stored);
            if (idx >= 0) {
              buttons.forEach(b => b.classList.remove('is-active'));
              buttons[idx].classList.add('is-active');
            }
          }
        } catch (e) {}
      }

      let activeIndex = Math.max(0, buttons.findIndex(b => b.classList.contains('is-active')));

      function setActive(idx, animate) {
        idx = Math.max(0, Math.min(buttons.length - 1, idx));
        buttons.forEach(b => b.classList.remove('is-active'));
        buttons[idx]?.classList.add('is-active');
        activeIndex = idx;
        const w = seg.getBoundingClientRect().width / buttons.length;
        thumb.style.transition = animate ? 'transform 220ms cubic-bezier(.2,.8,.2,1)' : 'none';
        thumb.style.width      = `${w}px`;
        thumb.style.transform  = `translateX(${idx * w}px)`;
      }

      seg.addEventListener('click', e => {
        const rect = seg.getBoundingClientRect();
        const idx  = Math.floor(((e.clientX - rect.left) / rect.width) * buttons.length);
        setActive(idx, true);
      });

      requestAnimationFrame(() => setActive(activeIndex, false));
      window.addEventListener('resize', () => setActive(activeIndex, false));
    });
  }

  // ── makeItemEl ───────────────────────────────────────────────────────────────
  function makeItemEl({ title, url, hasArrow, onClick, isActive, isStatic }) {
    const useLink = !onClick && !isActive && url && url !== '#';
    const el = document.createElement(useLink ? 'a' : 'button');
    el.className = ['mdock__item', isActive && 'is-active', isStatic && 'is-static'].filter(Boolean).join(' ');
    if (useLink) el.href = url || '#';
    if (!useLink) el.type = 'button';

    const labelSpan = document.createElement('span');
    labelSpan.className   = 'mdock__itemLabel';
    labelSpan.textContent = title;
    el.appendChild(labelSpan);

    if (hasArrow) {
      const arrowSpan = document.createElement('span');
      arrowSpan.className = 'mdock__itemArrow';
      el.appendChild(arrowSpan);
    }

    if (onClick) {
      el.addEventListener('click', e => {
        e.preventDefault();
        onClick();
      });
    }
    return el;
  }

  // ── makeAccordionBlock ───────────────────────────────────────────────────────
  function makeAccordionBlock(item, children) {
    const key   = getTitle(item);
    const block = document.createElement('div');
    block.className = 'mdock__accordionBlock';
    if (openAccordionKey === key) block.classList.add('is-open');

    const header = document.createElement('button');
    header.type  = 'button';
    header.className = 'mdock__accordionHeader';

    const titleSpan       = document.createElement('span');
    titleSpan.className   = 'mdock__accordionTitle';
    titleSpan.textContent = key;
    header.appendChild(titleSpan);

    const arrowSpan     = document.createElement('span');
    arrowSpan.className = 'mdock__accordionArrow';
    header.appendChild(arrowSpan);
    block.appendChild(header);

    const panelWrap      = document.createElement('div');
    panelWrap.className  = 'mdock__accordionPanelWrap';
    const panelDiv       = document.createElement('div');
    panelDiv.className   = 'mdock__accordionPanel';
    const panelInner     = document.createElement('div');
    panelInner.className = 'mdock__accordionPanelInner';

    const hasImages = children.some(c => c?.image || c?.img || c?.thumbnail || c?.handle);

    if (hasImages) {
      const grid     = document.createElement('div');
      grid.className = 'mdock__iconGrid';
      children.forEach(child => {
        const a       = document.createElement('a');
        a.className   = 'mdock__iconItem';
        a.href        = getUrl(child);
        a.addEventListener('click', close);

        const box     = document.createElement('div');
        box.className = 'mdock__iconBox';
        const imgUrl  = child?.image || child?.img || child?.thumbnail || getAutoAssetUrl(child);
        if (imgUrl) {
          const img   = document.createElement('img');
          img.alt     = getTitle(child);
          img.loading = 'lazy';
          img.src     = imgUrl;
          img.onerror = () => img.remove();
          box.appendChild(img);
        }
        const label       = document.createElement('div');
        label.className   = 'mdock__iconLabel';
        label.textContent = getTitle(child);
        a.appendChild(box);
        a.appendChild(label);
        grid.appendChild(a);
      });
      panelInner.appendChild(grid);
    } else {
      children.forEach(child => {
        const a = makeItemEl({ title: getTitle(child), url: getUrl(child), isStatic: true });
        a.style.marginBottom = '3px';
        a.addEventListener('click', close);
        panelInner.appendChild(a);
      });
    }

    panelDiv.appendChild(panelInner);
    panelWrap.appendChild(panelDiv);
    block.appendChild(panelWrap);

    header.addEventListener('click', () => {
      const isOpen = block.classList.toggle('is-open');
      openAccordionKey = isOpen ? key : null;
      body.querySelectorAll('.mdock__accordionBlock').forEach(other => {
        if (other !== block) other.classList.remove('is-open');
      });
    });

    return block;
  }

  // ── Events ───────────────────────────────────────────────────────────────────
  trigger.addEventListener('click', e => {
    e.preventDefault();
    open();
    renderLevel1(MENUS.root || []);
  });

  closeBtn?.addEventListener('click', close);
  overlay.addEventListener('click', close);
  panel.addEventListener('click', e => e.stopPropagation());
  root.querySelector('.mdock__sheet')?.addEventListener('click', e => e.stopPropagation());

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  gearBtn?.addEventListener('click', () => {
    if (!parentState) parentState = { items: MENUS.root || [] };
    renderPreferences();
  });

  searchInput.addEventListener('input', updateSearchArrow);

  searchInput.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      const q = searchInput.value.trim();
      if (q) window.location.href = buildViewAllUrl(q);
    }
  });

  searchSubmit?.addEventListener('click', () => {
    const q = searchInput.value.trim();
    if (q) window.location.href = buildViewAllUrl(q);
  });

})();